import type { PlaybookAsset } from '@carboncopyco/types';
import { Tooltip, Typography } from '@carboncopyco/ui';
import classNames from 'classnames';
import { type ReactNode, useRef } from 'react';
import { usePlaybookModalState } from '../PlaybookModalContext';
import { PLAYBOOK_ASSET_LIMIT } from '../consts';
import type { PlaybookSearchResult } from '../types';

export const PanelRowWrapper = ({
  item,
  children,
}: {
  item: PlaybookSearchResult & { isSelected: boolean };
  children: ReactNode;
}) => {
  const rowRef = useRef();
  const { assets, setAssets } = usePlaybookModalState();
  const maxAssetsSelected = assets.length >= PLAYBOOK_ASSET_LIMIT;
  const disabled = !item.isSelected && maxAssetsSelected;

  const onToggle = () => {
    if (item.isSelected) {
      setAssets(assets.filter(({ assetId }) => assetId !== String(item.id)));
      return;
    }
    if (assets.length >= 20) {
      return;
    }
    const newAsset: PlaybookAsset = {
      assetId: String(item.id),
      assetRevisionId: Number(item.revisionId),
      autoSync: true,
      assetType: item.entityType === 'overlay' ? 'demo' : item.entityType,
      entity: item,
    };
    setAssets([...assets, newAsset]);
  };

  return (
    <>
      <div
        ref={rowRef}
        onMouseDown={onToggle}
        className={classNames(
          'py-2 px-3 rounded-md mb-1 pointer',
          item.isSelected
            ? 'bg-ds-primary-50'
            : disabled
              ? ''
              : 'hover:bg-ds-natural-50',
          disabled ? 'hover:cursor-default' : 'hover:cursor-pointer '
        )}
      >
        {children}
      </div>
      {disabled && (
        <Tooltip
          delay={[300, undefined]}
          trigger="mouseenter"
          noArrow
          placement="top-start"
          anchorRef={rowRef}
        >
          <div className="p-3">
            <Typography
              fontSize="text-ds-200"
              lineHeight="leading-ds-200"
              color="text-ds-natural"
              fontWeight="font-ds-normal"
              letterSpacing="tracking-ds-tight"
              label={
                <div>
                  You’ve reached the <br />
                  maximum of 20 assets <br />
                  per Playbook.
                </div>
              }
            />
          </div>
        </Tooltip>
      )}
    </>
  );
};
